<template>
    <b-row>
        <b-col cols="12">
            <app-form-select-input
                :options="itemTypes"
                v-model="brand.itemTypeId"
                label="Tipo de Item"
                @change="$v.brand.itemTypeId.$touch()"
                :has-error="$v.brand.itemTypeId.$error"
                error-message="Debe seleccionar el tipo de item"
                :disabled="!!itemType"
            />
        </b-col>
        <b-col cols="12">
            <app-form-text-input
                v-model="brand.name"
                label="Marca"
                @input="$v.brand.name.$touch()"
                :has-error="$v.brand.name.$error"
                error-message="Debe diligenciar la marca"
            />
        </b-col>
    </b-row>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
    props: {
        itemType: {
            type: Object,
        },
    },
    data: () => ({
        brand: {
            name: '',
            itemTypeId: '',
        },
        itemTypes: [],
    }),
    validations: {
        brand: {
            name: { required },
            itemTypeId: { required },
        },
    },
    computed: {},
    methods: {
        async save() {
            this.$v.$touch()
            if (this.$v.$invalid)
                return toastr.error('Debe diligenciar los campos correctamente')

            const { data } = await repo.post('item-brands', this.brand)

            if (data.status) {
                toastr.success('Marca creada satisfactoriamente')
                this.$emit('created', data.result)
            } else {
                toastr.error(data.msg)
            }
        },
        async loadItemTypes() {
            const { data } = await repo.get('item-types')
            this.itemTypes = data
        },
    },
    mounted() {
        if (!!this.itemType) {
            this.itemTypes.push(this.itemType)
            this.brand.itemTypeId = this.itemType.id
        } else {
            this.loadItemTypes()
        }
    },
}
</script>
